import {
    CreatePreAlertRequest,
    createPreAlert,
} from "domains/incoming-stock-notifications/services/incoming-stock-notification-service";
import { EnterCustomerSpecificDetailsStage, EnterDetailsStage, PreAlertConfirmationStage, SelectItemsStage } from "./stages";
import Wizard, { WizardStep } from "features/common/Wizard";
import { useCallback, useState } from "react";

import { IntroStage } from "features/common/stages";
import localisations from "../../localisation";

type CreatePreAlertFeatureProps = {
    fieldCompanyId: number;
};

export default function CreatePreAlertFeature(props: CreatePreAlertFeatureProps) {
    const [fields, setFields] = useState({} as any);
    const { intro, enterDetails, enterCustomerSpecificDetails, selectItems, confirmation } =
        localisations.createPreAlert.stepper;

    const handleFieldChange = useCallback(
        (newFields: any) => setFields((x: any) => ({ ...x, ...newFields })),
        [setFields]
    );

    const [customerSpecificDetailsStageDisableNextButton, setCustomerSpecificDetailsStageDisableNextButton] =
        useState(true);
    const [enterDetailsStageDisableNextButton, setEnterDetailsStageDisableNextButton] = useState(true);
    const [selectItemsStageDisableNextButton, setSelectItemsStageDisableNextButton] = useState(true);

    const createPreAlertFromFeatureFields = async () => {
        await createPreAlert({
            fieldCompanyId: props.fieldCompanyId,
            partitionId: fields.partitionDetails.id,
            supplierId: fields.supplierDetails.id,
            destinationWarehouseId: fields.warehouseDetails.id,
            requiredDate: fields.requiredDate,
            reference: !fields.customerFields ? null : fields.customerFields["po2Number"] ?? null,
            procurementNumber: !fields.customerFields ? null : fields.customerFields["po2Number"] ?? null,
            comments: null,
            additionalData: !fields.customerFields
                ? null
                : Object.keys(fields.customerFields).map((key: string) => {
                      return {
                          key: key,
                          value: fields.customerFields[key],
                      };
                  }),
            items: !fields.items
                ? null
                : fields.items.map((m: any) => {
                      return {
                          productId: m.productId,
                          quantity: m.quantity,
                          unitCost: m.unitValue,
                          currencyCode: m.currencyCode,
                          reference: null,
                          partNumber: null,
                          comments: m.materialNumber,
                          additionalData: [{ key: "NSS Material Number", value: m.materialNumber }],
                      };
                  }),
        } as CreatePreAlertRequest);

        return true;
    };

    const steps = [
        {
            label: intro,
            component: <IntroStage localisations={localisations.createPreAlert.stages.intro} />,
        },
        {
            label: enterDetails,
            component: (
                <EnterDetailsStage
                    fieldCompanyId={props.fieldCompanyId}
                    fields={fields}
                    handleFieldChange={handleFieldChange}
                    onDisableNextButton={setEnterDetailsStageDisableNextButton}
                />
            ),
            disableNextButton: () => enterDetailsStageDisableNextButton,
        },
        {
            label: enterCustomerSpecificDetails,
            component: (
                <EnterCustomerSpecificDetailsStage
                    fields={fields}
                    handleFieldChange={handleFieldChange}
                    onDisableNextButton={setCustomerSpecificDetailsStageDisableNextButton}
                />
            ),
            disableNextButton: () => customerSpecificDetailsStageDisableNextButton,
        },
        {
            label: selectItems,
            component: (
                <SelectItemsStage
                    fieldCompanyId={props.fieldCompanyId}
                    fields={fields}
                    handleFieldChange={handleFieldChange}
                    onDisableNextButton={setSelectItemsStageDisableNextButton}
                />
            ),
            disableNextButton: () => selectItemsStageDisableNextButton,
        },
        {
            label: confirmation,
            component: <PreAlertConfirmationStage fields={fields} />,
            onNext: createPreAlertFromFeatureFields,
        },
    ] as WizardStep[];

    return (
        <Wizard
            fieldCompanyId={props.fieldCompanyId}
            steps={steps}
            resultStageLocalisations={localisations.createPreAlert.stages.result}
            serverErrorLocalisations={localisations.createPreAlert.serverErrors}
        />
    );

    //TODO: Write a test around this feature
}
